import templateUrl from "emun.order/import-items/order-import-items.htm";
import OrderImportItemsController from "emun.order/import-items/order-import-items.controller";
import open from "webmodals/open";

let OrderImportItems = options => {
  let modalInstance = open({
    size: options.size || "lg",
    templateUrl: options.templateUrl || templateUrl,
    controller: OrderImportItemsController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default OrderImportItems;
